import React from 'react'
import { MediaFormatLabel } from 'frontend/enums'
import { Count, FilterProp } from 'frontend/types'
import { activeOptionLabel } from 'frontend/utils/helpers'
import { filterMediaFormatClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import styles from './Format.module.css'
import classnames from 'classnames'
import { SearchParams } from 'backend/services/types/urApiService.types'

type FormatProps = {
  formats: FilterProp[]
  searchParams: SearchParams
  updateSearch: (params: SearchParams) => void
  count: Count
  className?: string
}

const Format = ({
  formats,
  searchParams,
  updateSearch,
  count,
  className,
}: FormatProps) => {
  const { format: mediaFormat } = searchParams
  const ALL_MEDIA = 'all'

  const formatWithAll = [
    {
      label: MediaFormatLabel.ALL,
      value: ALL_MEDIA,
      available: true,
    },
    ...formats,
  ]

  const activeLabel = mediaFormat ? activeOptionLabel(formats, mediaFormat) : []

  const handleOptionSelect = (option: FilterProp) => {
    const isSelected = activeLabel.includes(option.label)

    if (!isSelected) filterMediaFormatClick(option.value as string)

    updateSearch({
      format: isSelected || option.value === ALL_MEDIA ? '' : option.value,
    })
  }

  const getCountForFormat = (formatLabel: string) => {
    switch (formatLabel) {
      case MediaFormatLabel.ALL:
        return count.total
      case MediaFormatLabel.VIDEO:
        return count.video
      case MediaFormatLabel.AUDIO:
        return count.audio

      default:
        return 0
    }
  }

  return (
    <div className={classnames(styles.wrapper, className)}>
      {formatWithAll.map(format => {
        const isActive =
          (activeLabel.length < 1 && format.label === MediaFormatLabel.ALL) ||
          activeLabel.includes(format.label)

        const formatCount = getCountForFormat(format.label)

        return (
          <div
            key={format.value}
            className={classnames(styles.radio, {
              [`${styles.active}`]: isActive,
            })}
          >
            <input
              className={styles.radioButton}
              name="format"
              id={format.value}
              type="radio"
              checked={isActive}
              onChange={() => {
                handleOptionSelect(format)
              }}
            />
            <label htmlFor={format.value}>
              {format.label}
              {` (${formatCount})`}
            </label>
          </div>
        )
      })}
    </div>
  )
}

export default Format
